// Shared size-availability indicator helper.
// Used by main "Shop this look", "Styled for you costs", and LB3 gap rows
// to render a consistent size pill (e.g. "Your size: M" / "Look for UK 10").

export type ActiveSize = {
  gender: "women" | "men";
  uk_number: string | null;
  top_letter: string | null;
  shoe: string | null;
  trouser_waist: string | null;
  trouser_length: string | null;
  shoe_mens: string | null;
};

export type SizeLabelResult = {
  status: "confirmed" | "check" | "none";
  label: string;
};

export function getSizeLabelForItem(
  item: { category?: string | null },
  p: ActiveSize | null,
): SizeLabelResult {
  if (!p) return { status: "none", label: "" };
  const category = (item.category ?? "").toString().toLowerCase();
  const isTop = category === "top" || category === "outerwear";
  const isBottom = category === "bottom" || category === "dress";
  const isShoes = category === "shoes";
  if (isTop && p.top_letter) {
    return { status: "confirmed", label: `Your size: ${p.top_letter}` };
  }
  if (isBottom) {
    if (p.gender === "women" && p.uk_number) {
      return { status: "confirmed", label: `Look for UK ${p.uk_number}` };
    }
    if (p.gender === "men" && p.trouser_waist) {
      return { status: "confirmed", label: `Look for ${p.trouser_waist}" waist` };
    }
  }
  if (isShoes) {
    const sz = p.gender === "women" ? p.shoe : p.shoe_mens;
    if (sz) return { status: "confirmed", label: `Look for UK ${sz}` };
  }
  return { status: "check", label: "Check size on site" };
}
